module.exports = __webpack_public_path__ + "images/9b015ff59ee0a28f6c7cc58747985670.png";